import { render, staticRenderFns } from "./LeadsProforme.vue?vue&type=template&id=85611e6a"
import script from "./LeadsProforme.vue?vue&type=script&lang=js"
export * from "./LeadsProforme.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports